var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('JBox',[_c('JBox',{staticClass:"s-mx-auto s-max-w-4xl s-pt-10"},[_c('AppInfo')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }